import { useState, useEffect, useRef } from "react";

// options: array of { id, work_type, category }
export default function PersonnelNameInput({ value, options, onInputChange, onSelect }) {
  const [suggestions, setSuggestions] = useState([]);
  const [focused, setFocused] = useState(false);
  const wrapperRef = useRef();

  // 외부 클릭 시 드롭다운 닫기
  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setFocused(false);
        setSuggestions([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 입력값 변화에 따른 필터링
  useEffect(() => {
    if (!value) {
      setSuggestions([]);
      return;
    }

    const lower = value.toLowerCase();

    const filtered = options
      .filter(opt =>
        opt.work_type.toLowerCase().includes(lower) ||
        opt.category.toLowerCase().includes(lower)
      )
      .slice(0, 10);

    setSuggestions(filtered);
  }, [value, options]);

  return (
    <div ref={wrapperRef} className="relative">
      <input
        type="text"
        value={value}
        onFocus={() => setFocused(true)}
        onChange={(e) => onInputChange(e.target.value)}
        className="w-full border rounded px-2 py-1"
      />

      {/* focused + suggestions 조건으로 표시 */}
      {focused && suggestions.length > 0 && (
        <ul className="absolute left-0 right-0 mt-1 bg-white border rounded shadow-md z-50 max-h-40 overflow-auto">
          {suggestions.map(opt => (
            <li
              key={opt.id}
              className="px-2 py-1 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                onSelect(opt);
                setFocused(false);
                setSuggestions([]);
              }}
            >
              {opt.work_type} ({opt.category})
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
